'use client'

import { useEffect, PropsWithChildren, useRef, useCallback } from 'react'

const BaseConversationContent = (props: PropsWithChildren) => {
  const contentRef = useRef<HTMLDivElement>(null)

  const scrollToBottom = useCallback(() => {
    requestAnimationFrame(() => {
      contentRef.current?.scrollTo(0, contentRef.current.scrollHeight)
    })
  }, [])

  useEffect(scrollToBottom, [scrollToBottom])

  return (
    <div className="thread__content" ref={contentRef} data-testid="conversation-content">
      <div className="u-ui-margin-top-large" {...props} />
    </div>
  )
}

export default BaseConversationContent
